import React, { useState } from 'react';
import axios from 'axios';

const FeedbackModal = ({ isOpen, onClose }) => {
  const [category, setCategory] = useState('general');
  const [description, setDescription] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!description.trim()) {
      alert('Please provide a description');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/feedback', {
        category,
        description,
        screenshot_url: screenshot // For now, we'll skip screenshot upload
      });
      
      alert('Thank you for your feedback! We appreciate your input.');
      setCategory('general');
      setDescription('');
      setScreenshot(null);
      onClose();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl max-w-2xl w-full border border-transparent dark:border-slate-700">
        <div className="flex bg-blue-600 rounded-xl justify-between items-center p-6 border-b">
          <h2 className="text-lg sm:text-xl font-bold text-white">📝 Report Issue / Feedback</h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-white/80 hover:text-white text-2xl sm:text-3xl font-bold w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full hover:bg-white/15 transition-all"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Category */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
              <strong>Category *</strong>
            </label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 dark:border-slate-600 dark:bg-slate-950 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="bug">🐛 Bug Report</option>
              <option value="feature_request">💡 Feature Request</option>
              <option value="general">💬 General Feedback</option>
            </select>
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
              <strong>Description *</strong>
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Please describe the issue or feedback in detail..."
              className="w-full px-4 py-2 border border-gray-300 dark:border-slate-600 dark:bg-slate-950 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[150px]"
              required
            />
          </div>

          {/* Screenshot (optional) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
              <strong>Screenshot (Optional)</strong>
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setScreenshot(e.target.files[0])}
              className="w-full px-4 py-2 border border-gray-300 dark:border-slate-600 dark:bg-slate-950 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Upload a screenshot to help us understand the issue better
            </p>
          </div>

          {/* Submit */}
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 dark:border-slate-600 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-slate-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {submitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
